import { USERS_ERROR, GET_USER, GET_USERS, CLEAR_USER, TOGGLE_FAVORITE, AUTH_ERROR_CLIENT, LOGOUT_CLIENT } from '../actions/types';

const initialState = {
  user: {},
  pass: false,
  users: [],
  loading: true,
  error: {}
}

export default function(state = initialState, action){
  const { type, payload } = action;

  switch(type){
    case GET_USER: {
      // Las respuestas de editar el perfil (celular, correo, nombre, foto…) no dicen si la cuenta tiene contraseña: de la misma persona se
      // conserva lo que ya se sabía (lo trae /api/auth/client). Sin esto, después de editar algo el modal de la contraseña creía que no
      // tenía y no pedía la actual.
      const misma = payload?._id && state.user?._id && String(payload._id) === String(state.user._id);
      const user = misma && payload.pass === undefined && state.user.pass !== undefined ? { ...payload, pass: state.user.pass } : payload;
      if(user?.pass){
        return {
          ...state,
          user,
          pass: user.pass,
          loading: false
        }
      } else {
        return {
          ...state,
          user,
          loading: false
        }
      }
    }
    case GET_USERS:
      return {
        ...state,
        users: payload,
        loading: false
      }
    case USERS_ERROR:
      return {
        ...state,
        error: payload,
        loading: false
      }
    case TOGGLE_FAVORITE:
      return {
        ...state,
        user: { ...state.user, favorites: payload },
        loading: false
      }
    case CLEAR_USER: 
    case AUTH_ERROR_CLIENT:
    case LOGOUT_CLIENT:
      return {
        ...state,
        user: {},
        loading: false
      };
    default:
      return state;
  }
}